import { OrganizationSchema } from '@99designs/marketing-ui';
import VPCategoryPageLayout from '../components/VPCategoryPage/VPCategoryPageLayout';
import type { Site } from '@99designs/site-navigation/lib/Site';
import type { VPProductGroup, VPProductLandingGroupKey } from './vpProductLandingGroups';

export interface VPProductLandingPageProps {
    categoryKey: string;
    site: Site;
    productGroup: VPProductGroup;
}

export function VPProductLandingPage({
    categoryKey,
    site,
    productGroup,
}: VPProductLandingPageProps) {
    return (
        <>
            <VPCategoryPageLayout
                site={site}
                categoryKey={categoryKey as VPProductLandingGroupKey}
                vpProductGroup={productGroup}
            />
            <OrganizationSchema
                lang={site.getLanguage().rfc.toLowerCase()}
                supportPhone={site.get('phone.support')}
                sameAs={[
                    `https://www.facebook.com/${site.getSocialMediaHandleFor('facebook')}`,
                    `https://twitter.com/${site.getSocialMediaHandleFor('twitter')}`,
                    'https://www.instagram.com/99designs',
                    'https://www.youtube.com/channel/UC-xU--XxSovzJq07jwmZrsw',
                    'https://www.pinterest.com/99designs',
                ]}
            />
        </>
    );
}

export default VPProductLandingPage;
